import { render, staticRenderFns } from "./likeList.vue?vue&type=template&id=f544b494&scoped=true&"
import script from "./likeList.vue?vue&type=script&lang=js&"
export * from "./likeList.vue?vue&type=script&lang=js&"
import style0 from "./likeList.vue?vue&type=style&index=0&id=f544b494&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f544b494",
  null
  
)

export default component.exports